import AxiosService from './AxiosService';

class BillingService {
  /*
   * Singleton ES6 pattern
   * https://www.sitepoint.com/javascript-design-patterns-singleton/
   */
  constructor() {
    if (!BillingService.instance) {
      BillingService.instance = this;
    }
    return BillingService.instance;
  }

  endpoint = '/billing';

  async setDefaultPaymentMethod(paymentMethodId) {
    throw new Error('Not implemented');
  }

  async setPaymentMethodOrder(paymentMethodIds) {
    const res = await AxiosService.post(
      `${this.endpoint}/payment/stripe/payment-methods`,
      {
        payment_method_ids: paymentMethodIds,
      }
    );

    // Need the status in the caller, so don't just return data
    return res;
  }

  async updateBillingSettings(payload) {
    const res = await AxiosService.patch(`${this.endpoint}/settings`, payload);

    return res;
  }

  async deletePaymentMethod(paymentMethodId) {
    const res = await AxiosService.post(
      `${this.endpoint}/payment/stripe/payment-methods/${paymentMethodId}/detach`
    );

    return res;
  }

  async changeToPlan(payload, preview = true) {
    const res = await AxiosService.post(
      `${this.endpoint}/business-license/change-to-plan${preview ? '?preview=true' : ''}`,
      payload
    );

    return res.data;
  }

  async cancelPendingChange(ids = []) {
    const res = await AxiosService.post(
      `${this.endpoint}/business-license/cancel-downgrade`,
      {
        business_license_ids: ids,
      }
    );

    return res.data;
  }

  async getInvoicesPage({ page = 1, pageSize, ordering }) {
    const res = await AxiosService.get(
      `${this.endpoint}/invoices?page=${page}&page_size=${pageSize}&ordering=${ordering}`
    );

    return res.data;
  }

  async getPaymentContact() {
    const res = await AxiosService.get(
      `${this.endpoint}/settings/payment-contact`
    );

    return res.data;
  }

  async createPaymentContact(payload) {
    const res = await AxiosService.post(
      `${this.endpoint}/settings/payment-contact`,
      payload
    );

    return res.data;
  }

  async updatePaymentContact(paymentContactId, payload) {
    const res = await AxiosService.put(
      `${this.endpoint}/settings/payment-contact/${paymentContactId}`,
      payload
    );

    return res.data;
  }

  async deletePaymentContact(paymentContactId) {
    const res = await AxiosService.delete(
      `${this.endpoint}/settings/payment-contact/${paymentContactId}`
    );

    return res.data;
  }
}

const instance = new BillingService();
Object.freeze(instance);

export default instance;
